import api from "../config/api";
import { tratarErroRequisicao } from "../helpers/Errors";
import { enviaMsgSucesso } from "../helpers/Notificacoes";
import { Item } from "../dto/Itens";

const { REACT_APP_BASE_URL } = process.env || "";

export class ItensService {
    private readonly baseUrl: string;
    private readonly onUnauthorized?: () => void;

    constructor(onUnauthorized?: () => void) {
        this.baseUrl = REACT_APP_BASE_URL!;
        this.onUnauthorized = onUnauthorized;
    }

    async get(path: string, options: RequestInit = {}) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.get(path, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(20000),
            });

            return response.data;
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async post(path: string, options: RequestInit = {}, payload: Item[]) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.post(path, payload, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(20000),
            });

            return enviaMsgSucesso(200, "Post Item", response.data);
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async put(path: string, options: RequestInit = {}, payload: Item[]) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.put(path, payload, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(20000),
            });

            return enviaMsgSucesso(200, "Put Item", response.data);
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async delete(path: string, options: RequestInit = {}) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.delete(path, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(20000),
            });

            return enviaMsgSucesso(200, "Delete Item", response.data);
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    private createTimeoutSignal(timeout: number): AbortSignal | undefined {
        const controller = new AbortController();
        setTimeout(() => controller.abort(), timeout);
        return controller.signal;
    }
}
